<template>
  <div class="file-uploader">
    <vee-file-input
      :key="fileInputKey"
      v-model="selectedFile"
      class="file-uploader__item file-uploader__item--input"
      :disabled="isLoading"
      show-size
      v-bind="$attrs"
      v-on="$listeners"
    />

    <v-btn
      class="file-uploader__item"
      color="success"
      dark
      small
      :disabled="!selectedFile || selectedFile.length === 0"
      :loading="isLoading"
      @click="onSubmit"
    >
      Upload
      <template v-slot:loader>
        {{ uploadProgress }}%
      </template>
    </v-btn>
    <v-btn
      class="file-uploader__item"
      color="error"
      dark
      small
      :disabled="!isLoading"
      @click="onCancel"
    >
      Cancel
    </v-btn>
  </div>
</template>

<script>
import { mdiWindowClose } from '@mdi/js'
import useFiles from '@/composables/api/files'
import VeeFileInput from '@/components/veeInputs/VeeFileInput.vue'
import { ref } from 'vue'

export default {

  components: {
    VeeFileInput,
  },
  props: {
    uploadType: {
      type: String,
      default: 'default',
    },
  },

  emits: ['uploadCanceled', 'uploadSuccess', 'uploadFailed'],

  setup(props, { emit }) {
    const {
      selectedFile, uploadProgress, isLoading, uploadFile, uploadScoringFile, uploadThumbFile, uploadCompanyLogoFile, cancelUpload,
    } = useFiles()

    const fileInputKey = ref(0)

    const onSubmit = async () => {
      try {
        let uploadedFile
        if (props.uploadType === 'scoring') {
          uploadedFile = await uploadScoringFile()
        } else if (props.uploadType === 'company_logo') {
          uploadedFile = await uploadCompanyLogoFile()
        } else if (props.uploadType === 'thumb') {
          uploadedFile = await uploadThumbFile()
        } else {
          uploadedFile = await uploadFile()
        }
        emit('uploadSuccess', uploadedFile)
        fileInputKey.value++
      } catch (error) {
        emit('uploadFailed', error)
        fileInputKey.value++
      }
    }

    const onCancel = async () => {
      cancelUpload()
      emit('uploadCanceled')
      fileInputKey.value++
    }

    return {
      isLoading,
      selectedFile,
      uploadProgress,

      uploadFile,

      onSubmit,
      onCancel,

      fileInputKey,

      icons: {
        mdiWindowClose,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.file-uploader {
  display: flex;
  align-items: center;
}

.file-uploader__item {
  margin: 0 5px;
}

.file-uploader__item--input {
  flex: 1 1 auto;
}
</style>
